import { CheckboxGroupOption } from '../ui/AppCheckboxGroup.types'
import { checkboxItemAll } from './constants'

export const isCheckboxItemChecked = (
  currentItem: string | string[],
  selectedItems?: string[]
) => {
  if (currentItem === checkboxItemAll) {
    return !selectedItems
  }

  return Array.isArray(currentItem)
    ? currentItem.every(item => selectedItems?.includes(item))
    : selectedItems?.includes(currentItem)
}

export const getModifiedCheckboxList = <T>(
  currentItem: { value: string | string[]; checked: boolean },
  options: CheckboxGroupOption<T>[],
  prevItems: string[] = []
) => {
  const itemsLengthWithoutAll = options.length - 1
  const isLastItemRemain = itemsLengthWithoutAll - prevItems.length <= 1

  if (
    currentItem.value === checkboxItemAll ||
    (isLastItemRemain && currentItem.checked)
  ) {
    return undefined
  }

  const valueArray = Array.isArray(currentItem.value)
    ? currentItem.value
    : [currentItem.value]

  if (!currentItem.checked) {
    const filtered = prevItems.filter(item => !valueArray.includes(item))
    return filtered.length > 0 ? filtered : undefined
  }

  return [...prevItems, ...valueArray]
}
